<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width row">
          <h4
            slot="header"
            class="col-12 card-title text-left p-0 m-0"
            v-if="dadosFuncionario"
          >
            <b>Funcionário:</b> {{ dadosFuncionario.nome }}
          </h4>
          <base-button
            slot="header"
            type="info"
            class="col-2 animation-on-hover float-left"
            @click="voltar()"
            ><i class="tim-icons icon-minimal-left"></i> Voltar</base-button
          >

          <div class="col-12">
            <nav>
              <div class="nav nav-tabs" id="nav-tab">
                <a
                  class="nav-item nav-link"
                  :class="menu == 1 ? 'active' : ''"
                  @click="menu = 1"
                  >Horário Limite</a
                >
                <a
                  class="nav-item nav-link"
                  :class="menu == 2 ? 'active' : ''"
                  @click="menu = 2"
                  >Horario Limite por Dia</a
                >
              </div>
            </nav>

            <div v-show="menu == 1" class="row p-2">
              <div class="col-6 mt-2">
                <el-select
                  placeholder="Selecione um horário"
                  class="select-success col-sm-12 pagination-select p-0"
                  v-model="horaLimite"
                >
                  <el-option
                    v-for="item of horariosLimite"
                    :key="item.value"
                    class="select-success"
                    :label="item.label"
                    :value="item.value"
                    >{{ item.label }}</el-option
                  >
                </el-select>
                <div class="row" style="margin-top: 10px;">
                  <p class="text-left">
                    <i class="fas fa-exclamation-triangle icon_alert"></i
                    ><b
                      >Atenção: Caso este funcionário termine a jornada de
                      trabalho após a meia-noite do dia seguinte, NÃO altere
                      nada aqui, ok.</b
                    >
                  </p>
                  <p class="text-left">
                    Se o funcionário, exemplo, entrar às <b>16:00</b> e sair às
                    <b>02:00</b> da manhã do dia seguinte, ajuste o horário
                    limite para sempre 1 hora a mais, neste caso <b>03:00</b>.
                    Caso ele saia as 4h, altere o limite para 5h e assim por
                    diante. Dessa forma, a batida dele de saída ficará na
                    posição correta no cartão de ponto.
                  </p>
                  <p class="text-left">
                    Caso o funcionário trabalhe alguns dias em horário comercial
                    e outros dias na madrugada, você também poderá
                    <b>configurar por dias</b>.
                  </p>
                  <p class="text-left">
                    Se ainda tiver dúvidas, temos tutoriais em vídeo na nossa
                    Central de Vídeos.
                    <a
                      target="_blank"
                      href="https://cartaodepontomrm.com.br/centraldevideos"
                      >Clique aqui</a
                    >
                  </p>
                </div>
                <base-button
                  type="success"
                  class="float-left"
                  @click="salvarHoraLimite()"
                  >Salvar</base-button
                >
              </div>
            </div>
            <div v-show="menu == 2">
              <div class="row p-2" v-show="menuHoraLimiteDiaria == 1">
                <div class="col-md-3 text-left">
                  <base-input
                    label="De"
                    type="date"
                    :max="moment(dataFinal).format('YYYY-MM-DD')"
                    v-model="dataInicial"
                  >
                  </base-input>
                </div>
                <div class="col-md-3 text-left">
                  <base-input
                    label="Até"
                    type="date"
                    :min="moment(dataInicial).format('YYYY-MM-DD')"
                    v-model="dataFinal"
                    :disabled="!dataInicial ? true : false"
                  >
                  </base-input>
                </div>

                <div class="col-md-2 text-left mt-3">
                  <base-button
                    type="success"
                    block
                    @click="listarHoraLimiteDiaria()"
                    >Pesquisar</base-button
                  >
                </div>

                <div class="col-md-2 text-left mt-3">
                  <base-button
                    type="success"
                    block
                    @click="novoHoraLimiteDiaria()"
                    >Novo</base-button
                  >
                </div>

                <table
                  v-if="listaHorasLimiteDiario.length > 0"
                  class="table table-hover table-bordered"
                >
                  <thead>
                    <tr>
                      <th scope="col">Período</th>
                      <th scope="col">Hora</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item of listaHorasLimiteDiario" :key="item.id">
                      <td>{{ item.inicio + " - " + item.fim }}</td>
                      <td>{{ item.hora }}</td>
                      <td>
                        <el-tooltip
                          content="Editar"
                          effect="light"
                          :open-delay="300"
                          placement="top"
                        >
                          <base-button
                            class="edit btn-link"
                            type="info"
                            size="sm"
                            icon
                            @click="atualizarHoraLimiteDiaria(item.id)"
                          >
                            <i class="tim-icons icon-pencil"></i>
                          </base-button>
                        </el-tooltip>
                      </td>
                      <td>
                        <el-tooltip
                          content="Excluir"
                          effect="light"
                          :open-delay="300"
                          placement="top"
                        >
                          <base-button
                            class="remove btn-link"
                            type="danger"
                            size="sm"
                            icon
                            @click="confirmDeletarHoraLimiteDiaria(item.id)"
                          >
                            <i class="tim-icons icon-simple-remove"></i>
                          </base-button>
                        </el-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row p-2" v-show="menuHoraLimiteDiaria == 2">
                <div class="col-md-3 text-left">
                  <base-input
                    label="De"
                    type="date"
                    :max="moment(dataFinal).format('YYYY-MM-DD')"
                    v-model="dataInicial"
                  >
                  </base-input>
                </div>
                <div class="col-md-3 text-left">
                  <base-input
                    label="Até"
                    type="date"
                    :min="moment(dataInicial).format('YYYY-MM-DD')"
                    v-model="dataFinal"
                    :disabled="!dataInicial ? true : false"
                  >
                  </base-input>
                </div>
                <div class="col-md-3 text-left">
                  <base-input
                    label="Horário Limite"
                    name="horaLimite"
                    type="text"
                    v-mask="'##:##'"
                    placeholder="Horário Limite"
                    v-model="horaLimiteDiaria"
                  />
                </div>
                <div class="col-md-3 text-left mt-3">
                  <base-button type="success" @click="gerarHoraLimiteDiaria()"
                    >Gerar</base-button
                  >
                </div>

                <div
                  class="row d-flex justify-content-between"
                  v-if="horariosDiariosLimite.length > 0"
                >
                  <div>
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 40%">Dia</th>
                          <th scope="col" style="width: 40%">Data</th>
                          <th scope="col" style="width: 20%">Horário Limite</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in horariosDiariosLimite"
                          :key="item.id"
                        >
                          <td>{{ item.dia }}</td>
                          <td>{{ item.data }}</td>
                          <td class="mt-0">
                            <base-input
                              type="text"
                              v-mask="'##:##'"
                              class="mt-0"
                              placeholder="Horário Limite"
                              v-model="item.horaLimite"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <base-button
                      type="success"
                      block
                      class="animation-on-hover"
                      style="margin: 0px 5px 5px 5px;"
                      @click="salvarHoraLimiteDiaria()"
                      >Salvar</base-button
                    >
                    <base-button
                      type="warning"
                      block
                      class="animation-on-hover"
                      style="margin: 0px 5px 0px 5px;"
                      @click="menuHoraLimiteDiaria = 1"
                      >Cancelar</base-button
                    >
                  </div>
                </div>
              </div>
              <div class="row p-2" v-show="menuHoraLimiteDiaria == 3">
                <div
                  class="row d-flex justify-content-between"
                  v-if="horariosDiariosLimiteSelecionado.length > 0"
                >
                  <div>
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 40%">Dia</th>
                          <th scope="col" style="width: 40%">Data</th>
                          <th scope="col" style="width: 20%">Horário Limite</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in horariosDiariosLimiteSelecionado"
                          :key="item.id"
                        >
                          <td>{{ item.dia }}</td>
                          <td>{{ item.data }}</td>
                          <td class="mt-0">
                            <base-input
                              type="text"
                              v-mask="'##:##'"
                              class="mt-0"
                              placeholder="Horário Limite"
                              v-model="item.hora"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <base-button
                      type="success"
                      block
                      class="animation-on-hover"
                      style="margin: 0px 5px 5px 5px;"
                      @click="editarHoraLimiteDiaria()"
                      >Editar</base-button
                    >
                    <base-button
                      type="warning"
                      block
                      class="animation-on-hover"
                      style="margin: 0px 5px 0px 5px;"
                      @click="menuHoraLimiteDiaria = 1"
                      >Cancelar</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  name: "cadastrar-escalas",
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      menu: 1,
      listaHorasLimiteDiario: [],
      menuHoraLimiteDiaria: 1,
      dadosFuncionario: "",
      horaLimite: "",
      horaLimiteDiaria: "", // serve para formatar
      horariosDiariosLimite: [],
      horariosDiariosLimiteSelecionado: [],
      horariosLimite: [
        {
          value: "00:00:00",
          label: "00:00",
        },
        {
          value: "01:00:00",
          label: "01:00",
        },
        {
          value: "02:00:00",
          label: "02:00",
        },
        {
          value: "03:00:00",
          label: "03:00",
        },
        {
          value: "04:00:00",
          label: "04:00",
        },
        {
          value: "05:00:00",
          label: "05:00",
        },
        {
          value: "06:00:00",
          label: "06:00",
        },
        {
          value: "07:00:00",
          label: "07:00",
        },
        {
          value: "08:00:00",
          label: "08:00",
        },
        {
          value: "09:00:00",
          label: "09:00",
        },
        {
          value: "10:00:00",
          label: "10:00",
        },
        {
          value: "11:00:00",
          label: "11:00",
        },
        {
          value: "12:00:00",
          label: "12:00",
        },
      ],
      dataFinal: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      dataInicial: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      isLoading: false,
    };
  },
  mounted() {
    let th = this;
    jwt.verify(this.$route.params.id, "qXTflPwOaD", function(err, decoded) {
      if (decoded) {
        th.listarFuncionario(decoded.data.idFuncionario);
      }
    });
  },
  methods: {
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    listarFuncionario(idFuncionario) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregado: idFuncionario,
      };
      this.axios
        .post("/api/empregado/selecionarEmpregadoPorId", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dadosFuncionario = response.data.data.dados[0];
          th.horaLimite = th.dadosFuncionario.hora_limite;
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
        });
    },
    salvarHoraLimite() {
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        hora_limite: this.horaLimite,
        id_funcionario: this.dadosFuncionario.id,
      };

      const that = this;
      that.isLoading = true;
      this.axios
        .post("/api/empregado/atualizarHoraLimite", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          that.searchQuery = "";
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Sucesso",
            "Hora limite atualizada com successo!",
            "success",
          );

          that.listarFuncionario(that.dadosFuncionario.id);
        })
        .catch((err) => {
          that.isLoading = false;
          console.log(err);
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao atualizar Hora limite!",
            "error",
          );
        });
    },
    voltar() {
      this.$router.push(`/pesquisarEmpregados`);
    },
    capitalizeFirstLetter(string) {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    gerarHoraLimiteDiaria() {
      this.horariosDiariosLimite = [];
      const primeiroDia = moment(this.dataInicial);
      const ultimoDia = moment(this.dataFinal);
      const diff = ultimoDia.diff(primeiroDia, "days");

      //listar todas as possiveis data dentro desse intervalo
      for (let i = 0; i <= diff; i++) {
        const day = moment(this.dataInicial).add(i, "day");
        this.horariosDiariosLimite.push({
          dia: this.capitalizeFirstLetter(
            String(
              moment(day)
                .locale("pt-br")
                .format("dddd")
                .split("-")[0],
            ),
          ),
          data: day.format("DD/MM/YYYY"),
          horaLimite: this.horaLimiteDiaria,
        });
      }
    },
    salvarHoraLimiteDiaria() {
      let th = this;
      this.isLoading = true;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        idFuncionario: this.dadosFuncionario.id,
        inicio: this.dataInicial,
        fim: this.dataFinal,
        hora: this.horaLimiteDiaria,
        dias: this.horariosDiariosLimite.map((hd) => {
          return {
            dia: moment(hd.data, "DD/MM/YYYY").format("YYYY-MM-DD"),
            hora: hd.horaLimite,
          };
        }),
      };
      this.axios
        .post("/api/horaLimite/criar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.menuHoraLimiteDiaria = 1;
          if (response.data.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Hora limite criada com successo!",
              "success",
            );
            th.listarHoraLimiteDiaria();
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              response.data.data.err || "Erro ao criar Hora limite!",
              "error",
            );
            th.menuHoraLimiteDiaria = 1;
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao criar Hora limite!",
            "error",
          );
        });
    },
    listarHoraLimiteDiaria() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idFuncionario: this.dadosFuncionario.id,
        inicio: this.dataInicial,
        fim: this.dataFinal,
      };
      this.axios
        .post("/api/horaLimite/listar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.status) {
            th.listaHorasLimiteDiario = response.data.data.dados;
          } else {
            that.showSwal(
              "auto-close",
              "Erro",
              "Erro ao listar Hora limite!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar Hora limite!",
            "error",
          );
        });
    },
    listarDiasLimiteDiaria(id) {
      let th = this;
      this.isLoading = true;
      this.horariosDiariosLimiteSelecionado = [];

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        idHoraLimite: id,
      };
      this.axios
        .post("/api/horaLimite/listarDias", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.status) {
            th.horariosDiariosLimiteSelecionado = response.data.data.dados;
          } else {
            that.showSwal("auto-close", "Erro", "Erro ao listar Dias", "error");
          }
          th.menuHoraLimiteDiaria = 3;
        })
        .catch((err) => {
          th.isLoading = false;
          th.menuHoraLimiteDiaria = 3;
          console.log(err);
          that.showSwal("auto-close", "Erro", "Erro ao listar Dias", "error");
        });
    },
    novoHoraLimiteDiaria() {
      this.horaLimiteDiaria = (this.horaLimite || "").slice(0, 5);
      this.menuHoraLimiteDiaria = 2;
    },
    atualizarHoraLimiteDiaria(id) {
      this.menuHoraLimiteDiaria = 3;
      this.listarDiasLimiteDiaria(id);
    },
    deletarHoraLimiteDiaria(id) {
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: id,
      };
      const that = this;
      that.isLoading = true;
      this.axios
        .post("/api/horaLimite/deletar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          that.searchQuery = "";
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Sucesso",
            "Hora limite excluída com successo!",
            "success",
          );

          that.listarHoraLimiteDiaria();
        })
        .catch((err) => {
          that.isLoading = false;
          console.log(err);
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao excluir Hora limite!",
            "error",
          );
        });
    },
    confirmDeletarHoraLimiteDiaria(id) {
      swal({
        title: "Tem certeza?",
        text: `Deseja realmente excluir o período?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Não!",
        buttonsStyling: false,
      })
        .then((response) => {
          if (response.value) {
            this.deletarHoraLimiteDiaria(id);
          }
        })
        .catch((err) => {});
    },
    editarHoraLimiteDiaria() {
      let th = this;
      this.isLoading = true;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.horariosDiariosLimiteSelecionado[0].idHoraLimite,
        dias: this.horariosDiariosLimiteSelecionado.map((hd) => {
          return {
            dia: moment(hd.data, "DD/MM/YYYY").format("YYYY-MM-DD"),
            hora: hd.hora,
          };
        }),
      };
      this.axios
        .post("/api/horaLimite/atualizar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.menuHoraLimiteDiaria = 1;
          if (response.data.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Hora limite editada com successo!",
              "success",
            );
            th.listarHoraLimiteDiaria();
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao editar Hora limite!",
              "error",
            );
            th.menuHoraLimiteDiaria = 1;
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao criar Hora limite!",
            "error",
          );
        });
    },
  },
};
</script>
<style>
.icon_alert {
  color: red;
  margin-right: 5px;
}
</style>
